import Modal from "../../../components/Modal";
import PageHeader from "../../../components/PageHeader";
import PageActions from "../../../components/PageActions";
import FilterModal from "../../../components/FilterModal";

import MetaForm from "./components/MetaForm";
import { MetaCard } from "./components/MetaCard";

import { metaIndividualFilterFields } from "./constants/filterFields";
import {
  MetaIndividualProvider,
  useMetaIndividual,
} from "./context/MetaIndividualContext";
import { useState } from "react";

const MetaIndividualContent = () => {
  const {
    filters,
    lojas,
    usuarios,
    isOpen,
    editingItem,
    openModal,
    closeModal,
    handleFieldChange,
    handleSearch,
    handleClear,
    metas,
    isLoading,
    handleSubmit,
    handleEdit,
    handleDelete,
  } = useMetaIndividual();

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const activeFiltersCount = Object.values(filters).filter(
    (value) => value !== null && value !== undefined && value !== ""
  ).length;

  const filterFields = metaIndividualFilterFields.map((field) => {
    const baseField = {
      ...field,
      value: filters[field.name as keyof typeof filters] || "",
    };

    if (field.name === "lojaId") {
      return {
        ...baseField,
        options: lojas.map((loja) => ({
          value: loja.id.toString(),
          label: loja.nome,
        })),
      };
    }

    return baseField;
  });

  return (
    <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-4 mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <PageHeader
          title="Gerenciar Metas Individuais"
          description="Aqui você pode administrar todas as metas individuais do sistema"
        />
        <PageActions
          onFilter={() => setIsFilterModalOpen(true)}
          onAdd={() => openModal()}
          addButtonText="Nova Meta Individual"
          activeFiltersCount={activeFiltersCount}
        />
      </div>

      <hr />

      <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {metas.map((meta, index) => (
          <MetaCard
            key={meta.id}
            meta={meta}
            onEdit={() => handleEdit(index)}
            onDelete={() => handleDelete(index)}
          />
        ))}
      </div>

      {metas.length === 0 && !isLoading && (
        <div className="py-12 text-center">
          <p className="text-neutral-500">Nenhuma meta encontrada</p>
        </div>
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        fields={filterFields}
        onFieldChange={handleFieldChange}
        onSearch={() => {
          handleSearch();
          setIsFilterModalOpen(false);
        }}
        onClear={handleClear}
      />

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        title={editingItem ? "Editar Meta" : "Nova Meta"}
      >
        {isOpen && (
          <MetaForm
            initialData={editingItem || undefined}
            onSubmit={handleSubmit}
            onCancel={closeModal}
            isLoading={isLoading}
            lojas={lojas}
            usuarios={usuarios}
          />
        )}
      </Modal>
    </main>
  );
};

const MetaIndividual = () => {
  return (
    <MetaIndividualProvider>
      <MetaIndividualContent />
    </MetaIndividualProvider>
  );
};

export default MetaIndividual;
